/* import __COLOCATED_TEMPLATE__ from './help-center-state.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { type FolderCounts } from 'embercom/lib/content-service/search-api';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    folderCounts?: FolderCounts;
  };
}

export default class HelpCenterStateComponent extends Component<Signature> {
  get helpCenterEnabledCount(): number {
    return this.args.folderCounts?.help_center_enabled ?? 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::HelpCenterState': typeof HelpCenterStateComponent;
    'knowledge-hub/filterable-list/table/cells/help-center-state': typeof HelpCenterStateComponent;
  }
}
